import {DisplaySizeFilter} from "@/poster-gallery/classes/display-size-filter";

export class SearchTerm {
    static filterType = 'searchTerm';

    static searchFieldLoadingClasses = '-search-field-loading';
    static searchFieldDisabledClasses = '-search-field-disabled';
    static searchFieldClasses = `${SearchTerm.searchFieldLoadingClasses} ${SearchTerm.searchFieldDisabledClasses}`;

    static LOADING_STATE = 'loading';
    static DISABLED_STATE = 'disabled';
    static ACTIVE_STATE = 'active';

    /**
     * @return {boolean}
     */
    wasFilterUpdated() {
        return this.oldSearchTerm !== this.searchTerm;
    }

    resetOldFilterState() {
        return this.oldSearchTerm = this.searchTerm;
    }

    setLoadingState() {
        this.state = SearchTerm.LOADING_STATE;
    }

    /**
     * @return {boolean}
     */
    isLoadingState() {
        return this.state === SearchTerm.LOADING_STATE;
    }

    setDisabledState() {
        this.state = SearchTerm.DISABLED_STATE;
    }

    /**
     * @return {boolean}
     */
    isDisabledState() {
        return this.state === SearchTerm.DISABLED_STATE;
    }

    setActiveState() {
        this.state = SearchTerm.ACTIVE_STATE;
    }

    /**
     * @return {boolean}
     */
    isActiveState() {
        return this.state === SearchTerm.ACTIVE_STATE;
    }

    static getStateClassMapForSearchField() {
        const map = {};
        map[this.LOADING_STATE] = this.searchFieldLoadingClasses;
        map[this.DISABLED_STATE] = this.searchFieldDisabledClasses;
        map[this.ACTIVE_STATE] = '';
        return map;
    }

    /**
     * @param {string} searchTerm
     */
    constructor(searchTerm) {
        this.searchTerm = searchTerm;
        this.oldSearchTerm = searchTerm;
        this.state = SearchTerm.ACTIVE_STATE;
    }

    /**
     * @return {string}
     */
    static readSearchTerm() {
        return $($('.js-search-field-input:visible')[0]).val();
    }

    /**
     * @return {SearchTerm}
     */
    static fromPageHtml() {
        return new this(SearchTerm.readSearchTerm());
    }

    /**
     * @param {string} url
     */
    updateUrl(url) {
        if (PMW.posterGallery.isSearchPage()) {
            const urlObj = new URL(url);
            urlObj.searchParams.set('s', this.searchTerm.toLowerCase());
            return urlObj.toString();
        }
        let urlObj = new URL(PMW.util.site_url('posters/search'));
        urlObj.searchParams.set('s', this.searchTerm.toLowerCase());
        const posterGalleryFilters = PMW.posterGallery.getPosterGalleryFiltersForUpdate(),
            newDisplaySizeFilter = new DisplaySizeFilter(DisplaySizeFilter.allFilterOption); // remove display size
        posterGalleryFilters.displaySizeFilter.handleUpdatedFilter(newDisplaySizeFilter);
        return posterGalleryFilters.updateUrlForAdvancedFilters(urlObj, true).toString();
    }

    /**
     * @param {SearchTerm} searchTermObject
     */
    handleUpdatedFilter(searchTermObject) {
        if (this.searchTerm === searchTermObject.searchTerm) {
            return;
        }
        this.searchTerm = searchTermObject.searchTerm;
        this.updateView();
    }

    updateView() {
        const searchInput = $('.js-search-field-input'),
            searchInputContainer = searchInput.closest('.js-input-field-container'),
            stateClassMap = SearchTerm.getStateClassMapForSearchField(),
            stateClasses = stateClassMap[this.state];
        searchInput.val(this.searchTerm);
        searchInputContainer.removeClass(SearchTerm.searchFieldClasses).addClass(stateClasses);

        if (this.isActiveState()) {
            searchInput.removeAttr('disabled');
        } else {
            searchInput.attr('disabled', '');
        }

        if (this.searchTerm !== '') {
            PMW.showClearIcon(searchInput);
        }
    }

    /**
     * @return {string}
     */
    getPopStateInfo() {
        return this.searchTerm;
    }
}